import { STATUS_LABELS, type AppointmentStatus } from '@barbeiropro/contracts';
import { cn } from '@/lib/utils';

const styles: Record<AppointmentStatus, string> = {
  requested: 'bg-brass/15 text-amber-ink ring-brass/40',
  confirmed: 'bg-accent text-accent-foreground ring-primary/25',
  in_progress: 'bg-primary text-primary-foreground ring-primary',
  completed: 'bg-muted text-muted-foreground ring-border',
  cancelled: 'bg-transparent text-muted-foreground line-through ring-border',
  no_show: 'bg-oxblood/10 text-oxblood-ink ring-oxblood/30',
};

export function StatusBadge({ status, className }: { status: AppointmentStatus; className?: string }) {
  return (
    <span className={cn('inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ring-1 ring-inset', styles[status], className)}>
      {STATUS_LABELS[status]}
    </span>
  );
}
